import {ROUTE_NAMES} from "@/router/index"
import useDeliveryStore from "@/stores/deliveryStore"
// import useContentStore from "@/stores/contentStore";
import Supabase from "@/plugins/Supabase";
import useSerStore from "@/stores/userStore";

const beforeEachGuard = (async (to) => {

    const deliveryStore = useDeliveryStore()
    // const contentStore = useContentStore()
    const userStore = useSerStore()

    const {data: dataSession} = await Supabase.auth.getSession()
    const sessionUser = dataSession.session?.user ?? null
    console.log('===> sessionUser', sessionUser)
    if (sessionUser && !userStore.hasUser()) {
        console.log('ns')
        userStore.setUser(sessionUser)
    }

    // go to pick delivery view if no delivery type is selected
    if (!deliveryStore.deliveryIsSet && to.name !== ROUTE_NAMES.PICK_DELIVERY_VIEW) return {name: ROUTE_NAMES.PICK_DELIVERY_VIEW}

    if (to.name === ROUTE_NAMES.LOGIN_VIEW && sessionUser) return {name: ROUTE_NAMES.HOME_VIEW}
    const protectedRoutes = [
        ROUTE_NAMES.CART_VIEW,
        ROUTE_NAMES.ACCOUNT_VIEW,
        ROUTE_NAMES.ORDERS_VIEW
    ]
    if (protectedRoutes.includes(to.name) && !sessionUser) return {name: ROUTE_NAMES.LOGIN_VIEW}

    return true

})

export default beforeEachGuard
